import { FC } from "react";
import { Modal } from "react-bootstrap-v5";
import { ErrorMessage, Field, Form, Formik } from 'formik'
import * as Yup from 'yup'
import { KTSVG } from "../../../../helpers/KTSVG";
import { showErrorAlert } from "../../../../helpers/alert";

interface Props {
    show: boolean,
    onClose: () => void,
    onSubmit: (data: any) => void,
    data?: any
}

export const AssignCreditsModel: FC<Props> = ({ show, data, onClose, onSubmit }) => {

    const initialForm = {
        id: data?.id || 0,
        description: data?.description || '',
        amount: data?.amount || '',
    }

    const validateSchema = Yup.object({
        id: Yup.number().required('This field is required'),
        description: Yup.string().required('This field is required').max(100, "Max 100 characters"),
        amount: Yup.number().required('This field is required').max(100, "Max 100 characters"),
    })

    const handleOnSubmit = async (values) => {
        showErrorAlert({title:'',message:'coming soon'})
        return
        onSubmit(values)
        onClose()
    }

    return (<Modal show={show} centered size="lg" backdrop="static" dialogClassName="team-admin-add-member-modal">
        <div className="modal-payment-method-payout">
            <div className="w-100 d-flex flex-row justify-content-between">
                <h1 className="modal-payment-method-payout__title">Assign Credits</h1>
                <div className="rm-style-3 cursor-pointer" onClick={onClose}>
                    <KTSVG path="/media/svg/nobilis/closeX.svg" className="rm-style-4" />
                </div>
            </div>
            <Formik enableReinitialize initialValues={initialForm} validationSchema={validateSchema} onSubmit={handleOnSubmit}>
                {({ values, isValid }) => {
                    return (<Form className='profile-admin-form  profile-form-base' style={{ display: 'contents' }}>
                        <div className="w-100">
                            <div className="tap-add-experience-2-section mt-6 gap-1 team-admin-add-member__card">
                                <div className='form-field'>
                                    <label className='field-label'>Description</label>
                                    <Field name='description' className='input' />
                                    <div className="tap-add-experience-2-input-footer">
                                        <span className="tap-add-experience-2-input-hint">
                                            describe assign
                                        </span>
                                        <span className="tap-add-experience-2-input-counter">{values?.description?.length}/100</span>
                                    </div>
                                    <ErrorMessage name='description' component="div" className="tap-add-experience-text text-danger" />
                                </div>
                                <div className='form-field'>
                                    <label className='field-label'>Amount</label>
                                    <Field name='amount' className='input' />
                                    <ErrorMessage name='amount' component="div" className="tap-add-experience-text text-danger" />
                                </div>
                            </div>
                        </div>
                        {/* ACTIONS */}
                        <div className="modal-payment-method-payout__actions">
                            <div role='button' onClick={onClose} className={`tap-add-experience-2-btn-secondary`}>
                                Cancel
                            </div>
                            <button type="button" onClick={handleOnSubmit} disabled={!isValid} className="tap-add-experience-2-btn-main">
                                <div className='tap-host-button-text tap-flex-center'>
                                    Add method
                                    &nbsp;<KTSVG path='/media/svg/nobilis/teams_and_partner/waitlist_nb_btn_icon_host_experience_btn.svg' />
                                </div>
                            </button>
                        </div>
                    </Form>)
                }}
            </Formik>
        </div>
    </Modal>);
}